<script setup>
import { useAppProductRequest } from '@/stores/appProductRequest';
const store = useAppProductRequest();

</script>

<template>

  <div class="modal_container">

    <div class="max-w-[600px] w-[600px] mx-auto mt-10 p-6 bg-white rounded-md shadow-md">
      <h2 class="text-2xl font-bold mb-4">상품 교환, 반품, 취소</h2>
      <form action="#" method="POST">
        <div class="mb-4">
          <label for="product" class="block text-sm font-semibold mb-2">교환, 반품, 취소할 상품 선택</label>
          <div class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500 max-h-[120px] overflow-y-auto">
            <ul>
              <li v-for="i in 10">
                <label :for="'product_'+i">
                  <input type="checkbox" :id="'product_'+i">
                  {{ i }}
                </label>
              </li>

            </ul>
          </div>
        </div>
        <div class="mb-4">
          <label for="title" class="block text-sm font-semibold mb-2">제목</label>
          <input type="text" name="title" id="title" class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
        </div>
        <div class="mb-4">
          <label for="reason" class="block text-sm font-semibold mb-2">사유</label>
          <textarea name="reason" id="reason" rows="4" class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500"></textarea>
        </div>
        <button type="submit" class="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition duration-200">제출</button>
      </form>
    </div>

  </div>

</template>

<style scoped>

.modal_container {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.reviewWrite_wrapper {
  width: 88%;
  max-width: 36rem;
  min-height: 88vh;
  background-color: #fefefe;
  padding: 1rem;
  border: 1px solid #888;
  max-height: 90vh;
}

.close {
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.productOptionList {
  display: flex;
  align-items: baseline;
  padding: 0.5rem 0;
}

.optionBody {
  overflow-y: auto;
  max-height: 70vh;
}
.optionFooter {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.selectClass {
  @apply border border-neutral-800 p-2 col-span-4 w-full;
}
.countBox {
  @apply py-2 px-3 inline-block bg-white rounded-lg dark:bg-slate-900 dark:border-gray-700;
}

</style>

